import React from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

const mapping = {
	"remove": 'times',
	"help": "question",
	"question-sign": "question-circle",
	"remove-sign": "times-circle",
	"plus-sign": "plus-circle",
	"minus-sign": "minus-circle",
	"exclamation-sign": "exclamation-circle",
	"info-sign": "info-circle",
	"sort": "sort-alt",
	"sort-up": "sort-alpha-up",
	"sort-down": "sort-alpha-down",
	"menu-hamburger": "bars",
	"ok": "check",
	"globe": "globe-americas",
}
export const Glyphicon = React.forwardRef((props, ref) => {

	const {backgroundColor, className, color = null, glyph, onClick, ...faProps} = props;
	
	const onClickHandler = () => {
		onClick?.();
	};

	const filledBackgroundIcons = [
		'question-sign',
		'plus-sign',
		'minus-sign',
		'remove-sign',
		'exclamation-sign',
		'info-sign',
	]

	if(filledBackgroundIcons.includes(glyph)) {
		return <span {...props} ref={ref} className={`glyphicon fa-layers fa-fw ${className || ''}`} onClick={() => onClickHandler()}>
            <FontAwesomeIcon icon={['fas', 'circle']} color={backgroundColor !== undefined ? backgroundColor : 'white'} />
			<FontAwesomeIcon icon={['fas', mapping[glyph] ?? glyph]}/>
        </span>
	}

	// Map the rest of the glyphicon properties to font-awesome properties
	return (
		<span {...props} ref={ref} className={`glyphicon fa-layers fa-fw ${className || ''}`} onClick={() => onClickHandler()}>
			<FontAwesomeIcon icon={['fas', mapping[glyph] ?? glyph]} color={color}/>
		</span>
	);
});


